<!-- IMPORTANT: each slot needs to have excatly one root element -->

<template>   
    <div class="atom-swap">
        <transition name="swap" mode="out-in">

            <template v-if="isPrimary">
                <slot name="primary" />
            </template> 

            <template v-else>
                <slot name="secondary" />
            </template> 

        </transition>
    </div>
</template>

<script>
export default {
    name: 'AtomSwap',
    props: {
        isPrimary: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style scoped>
.swap-enter-active,
.swap-leave-active {
    transition: opacity 0.3s ease;
}

.swap-enter-from,
.swap-leave-to {
    opacity: 0;
}

.swap-enter-to,
.swap-leave-from {
    opacity: 1;
}

.atom-swap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
</style>